const CAMERA_ANIMATION_LENGTH = 60;
const SCENE_BUILD_ANIMATION_LENGTH = 30;

export { CAMERA_ANIMATION_LENGTH, SCENE_BUILD_ANIMATION_LENGTH };
